import React from "react";
import gsap from "gsap";
import { useNavigate } from "react-router-dom";
import { isMobile } from "detect-touch-device";
import LocomotiveScroll from "locomotive-scroll";
import axios from "axios";
import setBodyColor from "./SetBodyColor";
import setSocialDisplay from "./SetSocialDisplay";
import setSocialPosition from "./SetSocialPosition";

class Contact extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      classForm: "block",
      classSent: "none",
      briefClassName: "",
      nameClassName: "",
      emailClassName: "",
      briefText: "Asunto.",
      nameText: "Tu nombre.",
      emailText: "Tu correo.",
      sendBtnClassName: "send-btn-disabled" 
    };
    this.brief = React.createRef();
    this.name = React.createRef();
    this.contact = React.createRef();
  }

  componentDidMount() {
    this.addListeners();
  }

  componentWillUnmount() {
    this.removeListeners();
  }

  componentDidUpdate() {}

  addListeners = () => {
    window.addEventListener("resize", this.onResize);
    this.brief.current.addEventListener("input", this.updateValue);
    this.name.current.addEventListener("input", this.updateValue);
    this.contact.current.addEventListener("input", this.updateValue);
  }

  removeListeners = () => {
    window.removeEventListener("resize", this.onResize);
    this.brief.current.removeEventListener("input", this.updateValue);
    this.name.current.removeEventListener("input", this.updateValue);
    this.contact.current.removeEventListener("input", this.updateValue);
  }

  updateValue = (event) => {
    if (event.target.id == "brief-input") {
      this.setState({
        briefClassName: "",
        briefText: "Tu one line brief.",
      });
    } else if (event.target.id == "name-input") {
      this.setState({
        nameClassName: "",
        nameText: "Tu nombre y cargo.",
      });
    } else {
      this.setState({
        emailClassName: "",
        emailText: "Tu correo.",
      });
    }

    let value = this.contact.current.value.trim();
    this.contact.current.value = value;

    if (this.brief.current.value == "" || this.brief.current.value.length < 3) {
      this.setState({
        sendBtnClassName: "send-btn-disabled"
      });
      return;
    }

    if (this.name.current.value == "" || this.name.current.value.length < 3) {
      this.setState({
        sendBtnClassName: "send-btn-disabled"
      });
      return;
    }

    if (this.contact.current.value == "" || this.contact.current.value.length < 3) {
      this.setState({
        sendBtnClassName: "send-btn-disabled"
      });
      return;
    }

    if (this.validateEmail(this.contact.current.value) == null) {
      this.setState({
        sendBtnClassName: "send-btn-disabled"
      });
      return;
    }

    this.setState({
      sendBtnClassName: "send-btn"
    });
  }

  onResize = (event) => {
    
  };

  clickSendBtn = (event) => {
    event.preventDefault();

    if (this.brief.current.value == "" || this.brief.current.value.length < 3) {
      this.setState({
        briefClassName: "errorInput",
        briefText: "Faltó tu one line brief.",
      });
      this.brief.current.value = "";
      this.brief.current.focus();
      return;
    }

    if (this.name.current.value == "" || this.name.current.value.length < 3) {
      this.setState({
        nameClassName: "errorInput",
        nameText: "Faltó tu nombre y cargo.",
      });
      this.name.current.value = "";
      this.name.current.focus();
      return;
    }

    if (this.contact.current.value == "" || this.contact.current.value.length < 3) {
      this.setState({
        emailClassName: "errorInput",
        emailText: "Faltó tu correo.",
      });
      this.contact.current.value = "";
      this.contact.current.focus();
      return;
    }

    if (this.validateEmail(this.contact.current.value) == null) {
      console.log(this.validateEmail(this.contact.current.value));
      return;
    }
    
    let userData = {
      brief: this.brief.current.value,
      name: this.name.current.value,
      contact: this.contact.current.value
    };
    axios.post("/form.php", userData).then((response) => {
      console.log("Good::");
      console.log(response);
      this.setState({
        classForm: "none",
        classSent: "block"
      });
      this.brief.current.value = "";
      this.name.current.value = "";
      this.contact.current.value = "";
    })
    .catch((error) => {
      console.log("Error::");
      console.log(error);
    });
  }

  validateEmail = (email) => {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  }

  render() {
    const { navigation } = this.props;
    return (
      <>
        <div className="container">
          <div className="row">
            <div className="col-12 text-center" style={{ display: this.state.classForm }}>
              <p>
                ¿Cuéntanos como te podemos ayudar?
              </p>
              <input type="text" placeholder={this.state.briefText} ref={this.brief} id="brief-input" className={this.state.briefClassName} autoComplete="off"></input>
              <p>
                Nombre
              </p>
              <input type="text" placeholder={this.state.nameText} ref={this.name} id="name-input" className={this.state.nameClassName} autoComplete="off"></input>
              <p>
                Tu correo
              </p>
              <input type="text" placeholder={this.state.emailText} ref={this.contact} id="email-input" className={this.state.emailClassName} autoComplete="off"></input>
            </div>
            <div className="col-12 text-center" style={{ display: this.state.classForm }}>
                <a href="#" onClick={this.clickSendBtn} className={this.state.sendBtnClassName}>Enviar</a>
            </div>
            <div style={{ display: this.state.classSent }} className="col-12 text-center"><h1 className="thank-you">Recibido. Volvemos contigo <span className="card-font-italic">muy pronto.</span></h1></div>
            <div className="col-12 text-center contact-whatsapp">
              <p>O escríbenos directo por WhatsApp</p>
              <div className="contact-whatsapp-links">
                <a href="https://wa.me/5215527175567" target="_blank" rel="noopener noreferrer">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
                  +52 55 2717 5567
                </a>
                <a href="https://wa.me/5215560336998" target="_blank" rel="noopener noreferrer">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
                  +52 55 6033 6998
                </a>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default function (props) {
  const navigation = useNavigate();
  return <Contact {...props} navigation={navigation} />;
}
